import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { ArrowLeft, Trash2 } from "lucide-react";

const MOODS = ["😢", "😔", "😕", "😐", "🙂", "😊", "🥰", "✨", "💖", "🌟"];

export default function JournalList() {
  const nav = useNavigate();
  const [list, setList] = useState(null);
  const load = async () => {
    try { const { data } = await api.get("/journal"); setList(data); }
    catch { setList([]); }
  };
  useEffect(() => { load(); }, []);

  const del = async (id) => {
    if (!window.confirm("Smazat tento záznam?")) return;
    await api.delete(`/journal/${id}`);
    load();
  };

  return (
    <div className="app-shell bg-aurora min-h-screen pb-10" data-testid="journal-list-page">
      <div className="px-6 pt-10 pb-5 flex items-center gap-3">
        <button onClick={() => nav("/breakup")} className="text-[#5F7F77]"><ArrowLeft size={20} strokeWidth={1.7} /></button>
        <div>
          <p className="text-xs uppercase tracking-[0.18em] text-[#5F7F77] font-medium">Tvůj deník</p>
          <h1 className="font-display text-3xl text-[#1A2924]">Všechny záznamy</h1>
        </div>
      </div>
      <div className="px-6 space-y-3">
        {list === null && [...Array(3)].map((_, i) => <div key={i} className="h-20 rounded-3xl shimmer" />)}
        {list?.length === 0 && <p className="text-center text-[#5F7F77] py-10">Zatím žádné záznamy.</p>}
        {list?.map((j) => (
          <div key={j.id} className="glass-card p-4" data-testid={`entry-${j.id}`}>
            <div className="flex items-center justify-between mb-1">
              <span className="text-xs text-[#5F7F77]">{new Date(j.created_at).toLocaleDateString("cs-CZ", { day: "numeric", month: "long", year: "numeric" })}</span>
              <div className="flex items-center gap-3">
                <span className="text-lg">{MOODS[j.mood - 1]}</span>
                <button onClick={() => del(j.id)} className="text-[#5F7F77]"><Trash2 size={14} /></button>
              </div>
            </div>
            <p className="text-sm text-[#1A2924] leading-relaxed whitespace-pre-wrap">{j.content}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
